import { Chip as MuiChip } from '@mui/material'

interface ChipProps {
  label: string
  variant?: 'outlined' | 'filled'
  style?: any
  size?: 'small' | 'medium'
  // eslint-disable-next-line prettier/prettier
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
  sx?: any
  onClick?: any
  icon?: any
  disabled?: boolean
}

export const Chip = (props: ChipProps) => {
  const { label, variant, style, size, color, sx, onClick, icon, disabled } =
    props

  return (
    <MuiChip
      style={style}
      color={color}
      sx={sx}
      label={label}
      variant={variant}
      size={size}
      onClick={onClick}
      icon={icon}
      disabled={!!disabled}
    />
  )
}

Chip.defaultProps = {
  variant: 'filled',
  size: 'small'
}
